module.exports = __webpack_public_path__ + "img/logo_white_to_card.89d62c2c.png";